<template>
    <v-layout wrap class="LivenessDemo">
        <v-flex lg6 md12 class="pr-1">
            <v-layout>
                <v-flex xs6 class="pr-1">
                    <input type="file" style="display: none" ref="image" @input="onFilePicked($event, true)">
                    <v-btn class="ml-0" @click="pickFile(true)">
                        {{ image.name || $t('selectImage') }}
                    </v-btn>
                    <br>
                    <img :src="image.url" alt="" style="max-width: 100%; max-height: 300px;">
                </v-flex>
                <v-flex xs6>
                    <input type="file" style="display: none" ref="video" @input="onFilePicked($event, false)">
                    <v-btn class="ml-0" @click="pickFile(false)">
                        {{ video.name || $t('selectVideo') }}
                    </v-btn>
                    <br>
                    <video :src="video.url" style="max-width: 100%; max-height: 300px;"></video>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-btn @click="check" color="primary">{{ $t('check') }}</v-btn>
                <table>
                    <tr>
                        <td><b>{{ $t('isMatch') }}</b></td>
                        <td>{{ result.face_match.isMatch }}</td>
                    </tr>
                    <tr>
                        <td><b>{{ $t('similarity') }}</b></td>
                        <td>{{ result.face_match.similarity }} %</td>
                    </tr>
                    <tr>
                        <td><b>Is live</b></td>
                        <td>{{ result.liveness.is_live }}</td>
                    </tr>
                    <tr>
                        <td><b>deep fake</b></td>
                        <td>{{ result.liveness.is_deepfake }}</td>
                    </tr>
                </table>
            </v-layout>
        </v-flex>
        <v-flex lg6 md12 style="text-align: left">
            <h2 class="py-2">API</h2>
            <v-select
                label="API Key"
                v-model="apiKey"
                :items="listAPIKey"
                class="mt-3"
            ></v-select>
            <v-layout row reverse wrap align-center>
                <v-btn
                    @click="$utils.copyToClipboard(code[apiType], $t('copiedToClipboard', ['code']))"
                    title="copy key to clipboard"
                    class="ma-0"
                    depressed
                    color="info"
                >
                    <v-icon>file_copy</v-icon>
                    Copy
                </v-btn>
                <v-radio-group v-model="apiType" row>
                    <v-radio label="cUrl " value="curl"></v-radio>
                    <v-radio label="Python" value="python"></v-radio>
                </v-radio-group>
            </v-layout>
            <code style="width: 100%">{{ code[apiType] }}</code>
        </v-flex>
    </v-layout>
</template>

<script>

import axios from 'axios'
import ApiDemo from '@/views/APIs/demo/ApiDemo'
import { inject } from '@/utils/VariableInjection'
/* eslint-disable */
import livenessPython from 'raw-loader!../code/livenessPython.txt'
import livenessCUrl from 'raw-loader!../code/livenessCUrl.txt'
/* eslint-enable */

export default {
    name: 'LivenessDemo',
    extends: ApiDemo,
    data () {
        return {
            image: {
                name: ''
            },
            video: {
                name: ''
            },
            result: {
                face_match: {},
                liveness: {}
            },
            demoUrl: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_LIVENESS
        }
    },
    computed: {
        code () {
            let variableMap = {
                url: this.demoUrl,
                apiKey: this.apiKey,
                image: this.image.name,
                video: this.video.name
            }
            return {
                python: inject(livenessPython, variableMap),
                curl: inject(livenessCUrl, variableMap)
            }
        }
    },
    methods: {
        pickFile (isImage) {
            if (isImage) {
                this.$refs.image.click()
            } else {
                this.$refs.video.click()
            }
        },
        onFilePicked (input, isImage) {
            const file = input.target.files[0]
            if (!file) {
                return
            }
            let target = isImage ? this.image : this.video
            target.file = file
            target.name = file.name
            let reader = new FileReader()
            reader.onload = e => {
                target.url = e.target.result
                this.$forceUpdate()
            }
            reader.readAsDataURL(file)
        },
        check () {
            if (!this.image.file || !this.video.file) {
                return
            }
            let formData = new FormData()
            formData.append('video', this.video.file)
            formData.append('cmnd', this.image.file)
            this.$appService.showLoading()
            axios.post(
                this.demoUrl,
                formData,
                {
                    headers: {
                        'api-key': this.apiKey,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(
                result => {
                    if (result.data.code === '200') {
                        this.result = result.data
                        this.parent.getRemain()
                    } else {
                        this.$appService.toastError(result.data.message)
                    }
                },
                this.$appService.handleRequestError(this.$t('error'))
            ).finally(this.$appService.hideLoading)
        }
    }
}
</script>

<style scoped lang="scss">
table tr td {
    padding-right: 10px;
}
</style>
